import { BENEFIT_SUBMITTED } from './benefit.types';

export const benefitSubmitted = values => ({
  type: BENEFIT_SUBMITTED,
  values,
});
